import { render, staticRenderFns } from "./IconThumbUpSolid.vue?vue&type=template&id=9ea516c4"
import script from "./IconThumbUpSolid.vue?vue&type=script&lang=js"
export * from "./IconThumbUpSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports